import React from 'react'
import { Link } from 'react-router-dom'

const Account = () => {
    return (
        <>
            <section>
                <div className="inner-banner-sec">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-12">
                                <div className="inner-banner-heading  wow fadeInLeft" data-wow-duration="2s">
                                    <h2>Login - signup</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="login-sec">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-12">
                                <div className="login-box  wow fadeInLeft" data-wow-duration="2s">
                                    <form>
                                        <h2>Log in Your Account</h2>
                                        <input type="text" name="User Name" placeholder="User Name" />
                                        <input type="password" name="Password" placeholder="Password" />
                                        <button type="submit">login</button>
                                        <ul>
                                            <li><Link to=""> <input type="checkbox" name /> Remind Me</Link></li>
                                            <li><Link to="">Forgot Password?</Link></li>
                                        </ul>
                                    </form>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-12">
                                <div className="login-box signup  wow fadeInRight" data-wow-duration="2s">
                                    <form>
                                        <h2>Register Your Account</h2>
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6 col-12">
                                                <input type="text" name="First Name" placeholder="First Name" />
                                            </div>
                                            <div className="col-lg-6 col-md-6 col-12">
                                                <input type="text" name="Last Name" placeholder="Last Name" />
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-12">
                                                <input type="email" name="Email Address" placeholder="Email Address" />
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-12">
                                                <input type="password" name="Enter Password" placeholder="Enter Password" />
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-12">
                                                <input type="password" name="Retype Password" placeholder="Retype Password" />
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-12">
                                                <div className="by-creating">
                                                    <p>By creating an account, You agree to our <Link to="">Term &amp; Conditions</Link></p>
                                                </div>
                                            </div>
                                        </div>
                                        <button type="submit">Create Account</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Account